import axios from "./configs/axiosConfig";

// The Agreement Sync tab whose behaviour differs server-side: it reads its own union rather than
// vwagreementmatchdata, and it is the only one the expired/cancelled filter applies to. Named here
// so the nine comparisons across the page, the grid and the download component cannot drift on a
// typo -- the handler names it once for the same reason (jbwagreementsyncdatalist's ALL_TAB).
export const ALL_TAB = "all";

// Options object rather than positional: this took seven arguments, and callers were passing
// `null` by position for the ones they did not need, which put tabType and searchAgreementId one
// slot apart with nothing to catch a swap.
//
// includeExpiredCancelled is sent as the literal string "true"/"false" because the handler widens
// the All tab for "true" and nothing else -- anything it does not recognise fails closed.
//
// quickFilter is the All tab's server-side search (the handler ignores it on the other tabs). It
// is free text, so it is the one value here that is encoded, and it is left off the URL entirely
// when empty.
export const getAgeementMatchDataList = async (
  dealerId,
  { datatype, page, limit, tabType, searchAgreementId, includeExpiredCancelled = false, quickFilter = "" } = {},
) => {
  const url = `agreementsync/${dealerId}?page=${page}&limit=${limit}&type=${datatype ? datatype: 'all'}&tabtype=${tabType? tabType:'unapproved'}&searchAgreementId=${searchAgreementId ? searchAgreementId: null}&includeExpiredCancelled=${includeExpiredCancelled ? "true" : "false"}${quickFilter ? `&q=${encodeURIComponent(quickFilter)}` : ""}`;
  return await axios.get(url);
};

// Counts only, for the Agreement Sync nav badge. Deliberately NOT getAgeementMatchDataList
// with a limit -- the sidebar renders on every screen, so this must never become a grid fetch.
export const getAgreementSyncOutstandingCount = async (dealerId) => {
  const url = `agreementsync/${dealerId}/outstandingcount`;
  return await axios.get(url);
};

export const updateAgeementMatchLocation = async (
  agreementMatchId,
  locationData
) => {
  const url = `agreementsync/${agreementMatchId}/location`;
  return await axios.put(url, locationData);
};

export const approveAgreements = async (agreementMatchIds, approvedBy) => {
  const url = `agreementsync/approve`;
  return await axios.put(url, { agreementMatchIds, approvedBy });
};

export const stDataSyncSpCall = async (dealerId) => {
  const url = `agreementsync/${dealerId}/spcall`;
  return await axios.get(url);
};

export const agreementSyncFileUpload = async (dealerId,data) => {
  const url = `/agreementsync/${dealerId}/fileupload `;
  return await axios.post(url,data);
};

export const dismissAgreement = async (matchid, status) => {
  const url = `agreementsync/dismissagreement?matchid=${matchid}&status=${status}`;
  return await axios.patch(url);
};

export const updateAgeementMatchLocationIdAndCustomerName = async (
  agreementMatchId,
  data
) => {
  const url = `agreementsync/${agreementMatchId}/update`;
  return await axios.put(url, data);
};
